import React from 'react'
import Footer from '../../components/footer/Footer';
import Navbar from '../../components/navbar/Navbar'
import "./Layout.css";
import { useLocation } from "react-router-dom";

export default function Layout({children}) {
  const { pathname } = useLocation();
  if (pathname === "/checkout" || pathname === "/checkout/shipping" || pathname === "/checkout/information" || pathname === "/checkout/payment" ) return <main>{children}</main>;
  else{
    return (
      <>
      <Navbar/>
      <div className='wrapper-container'>
          <main>{children}</main>
      </div>
      <Footer/>
      </>
    )
  }


  
}
